export const formatUSD = (value: number, fractionDigits: number) =>
	new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
		maximumFractionDigits: fractionDigits,
		minimumFractionDigits: fractionDigits,
	}).format(value)

export const formatMiles = (value: number, fractionDigits: number) =>
	new Intl.NumberFormat("en-US", {
		style: "unit",
		unit: "mile",
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits,
	}).format(value)

export const formatNumber = (value: number, fractionDigits: number) =>
	new Intl.NumberFormat("en-US", {
		style: "decimal",
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits,
	}).format(value)

export type ns = number | string

const fas = (f: (n: number) => string) => (n: ns) => typeof n == "string" ? n : f(n)

export const usd = fas((n) => formatUSD(n, 0))
export const usd2 = fas((n) => formatUSD(n, 2))
export const usd3 = fas((n) => formatUSD(n, 3))
export const mi2 = fas((n) => formatMiles(n, 2))
export const mi = fas((n) => formatMiles(n, 0))
export const num2 = fas((n) => formatNumber(n, 2))
export const num = fas((n) => formatNumber(n, 0))
